import axios from "axios";

export default {
  state: {
    users: [],
  },

  mutations: {
    SET_USERS(state, { data }) {
      state.users = data;
    },
    UPDATE_USER(state, updatedUser) {
      if (!state.users.data) return;

      const index = state.users.data.findIndex(
        (user) => user.id === updatedUser.id
      );

      if (index !== -1) {
        state.users.data.splice(index, 1, updatedUser);
      }
    },
  },

  actions: {
    async fetchUsers({ commit }, { page = 1, search = "" } = {}) {
        try {
          const response = await axios.get("/api/users", {
              params: {
                page: page,
                search: search,
              },
          });

          commit("SET_USERS", {
              data: response.data,
          });

          return response;
        } catch (error) {
          throw error;
        }
    },

    async toggle2FA({ commit }, userId) {
      try {
        const { data: response } = await axios.post(
            `/api/users/${userId}/settings/2fa`
        );

        commit("UPDATE_USER", response.data);

        window.emitter.emit("alertSuccess", {
          message: response.data.two_factor_auth
            ? "2FA is enabled successfully!"
            : "2FA is disabled successfully!",
        });

        return response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async resetPassword({ commit }, { password, password_confirmation }) {
        try {
            const token = document.head.querySelector('meta[name="csrf-token"]')?.content;
            
            const { data: response } = await axios.post('/api/password/reset', {
            password,
            password_confirmation
            }, {
            headers: {
                'X-CSRF-TOKEN': token
            }
            });
        
            window.emitter.emit("alertSuccess", {
                message: "Password has been updated successfully!",
                alertType: 'success',
                timer: 20
            });
        
            setTimeout(() => {
                window.location.reload();
            }, 2200);

            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || 
                                error.response?.data?.error ||
                                'Password reset failed';
        
            window.emitter.emit("alertSuccess", {
                message: errorMessage,
                alertType: 'danger',
                timer: 20
            });
        } finally {
            window.emitter.emit("changeLoaderStatus", false);
        }
    },
},

  getters: {
    getData: (state) => state.data,
    getCurrentUsers: (state) => state.users,
  },
};
